import { ResidenceRegion } from '@api/btlApplicationForm/types';
import { TypedFormatMessageFn } from '@app-types/intl';

export function formatCurrency(value?: number | null): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    maximumFractionDigits: 0,
  }).format(value ?? 0);
}

export function formatRegion(region: ResidenceRegion | null | undefined, formatMessage: TypedFormatMessageFn): string {
  if (!region) {
    return '-';
  }

  const regionLabels: Record<ResidenceRegion, string> = {
    [ResidenceRegion.NORTH_EAST]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.0.label',
    }),
    [ResidenceRegion.NORTH_WEST]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.1.label',
    }),
    [ResidenceRegion.YORKSHIRE_AND_THE_HUMBER]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.2.label',
    }),
    [ResidenceRegion.EAST_MIDLANDS]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.3.label',
    }),
    [ResidenceRegion.WEST_MIDLANDS]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.4.label',
    }),
    [ResidenceRegion.EAST_OF_ENGLAND]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.5.label',
    }),
    [ResidenceRegion.LONDON]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.6.label',
    }),
    [ResidenceRegion.SOUTH_EAST]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.7.label',
    }),
    [ResidenceRegion.SOUTH_WEST]: formatMessage({
      id: 'btlApplicationForm.TOP_SLICING_HOUSEHOLD.household.residenceRegion.8.label',
    }),
  };

  return regionLabels[region] ?? region;
}

export function formatYesNo(value: boolean, formatMessage: TypedFormatMessageFn): string {
  return formatMessage({ id: value ? 'common.yes' : 'common.no' });
}
